import { useMemo } from "react";

import useUserSession from "./use-user-session";

export default function useCurrentUser() {
  const { userSession } = useUserSession();

  const user = useMemo(() => {
    if (!userSession) return null;
    return {
      user_id: userSession.user.user_id,
      email: userSession.user.email ?? "",
      default_org_id: userSession.org_id,
      name: userSession.user.display_name,
      photo_url: userSession.user.photo_url ?? "",
      organizations: userSession.organizations,
    };
  }, [userSession]);

  return user;
}
